<template>
  <div>
    <breadcrumbs home="Personal information"/>

    <v-card flat width="100%">

    <v-form v-model="valid" ref="form">
    <v-container class="px-6 pt-6 purtrak-scrollable" fluid>
      <v-row>
        <v-col cols="12" sm="5">
          <v-text-field label="Email" v-model="user.email" :counter="50" outlined dense disabled/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="5">
          <v-text-field label="Name" v-model="user.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
      </v-row>
    </v-container>

    </v-form>
    <v-divider/>
    <v-card-actions class="pr-6">
      <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
    </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ConfigurationUserInfo',
  mixins: [confirmLeave],
  data() {
    return {
      valid: true,
      dirty: false,
      saving: false,
      user: {}
    }
  },
  watch: {
    user: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async mounted() {
    const response = await this.$auth.user(this.$store.state.user.sub);
    if (response.status === 200)  {
      this.user = response.data;
      this.$nextTick(() => {
        this.dirty = false;
      });
    }
    else
      this.$store.commit('setError', {type:'error',message:response.data});
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

        const response = await this.$auth.userUpdate(this.$store.state.user.sub, {name:this.user.name});
        if (response.status === 200) {
          this.$store.state.user.name = this.user.name;
          this.$nextTick(() => {
            this.dirty = false;
            this.$router.back();
          });
        }
        else
          this.$store.commit('setError', {type:'error',message:response.data.error_message});
    }
  }
}
</script>